"use client";

import * as motion from "motion/react-client";
import { ReactNode, useRef } from "react";
import { rh } from "../../hooks";
import { Scroll } from "./Scroll";

export function ScrollXContainer({ children }: { children: ReactNode }) {
  const ref = useRef(null);

  return (
    <Scroll
      options={{
        container: ref,
        offset: ["start start", "end end"],
        axis: "x"
      }}
      render={({ scrollXProgress }) => {
        const maskImage = rh.useScrollXOverflowMaskImage(scrollXProgress);
        return (
          <div className="scroll-x-container">
            <motion.div
              ref={ref}
              className="scrollable"
              style={{ maskImage }}>
              {children}
            </motion.div>
            <StyleSheet />
          </div>
        );
      }}></Scroll>
  );
}

function StyleSheet() {
  return (
    <style>{`
      .scroll-x-container {
        width: 100%;
        position: relative;
      }
      .scroll-x-container .scrollable {
        display: flex;
        overflow-x: scroll;
        margin: 0 auto;
      }
    `}</style>
  );
}
